var _defs, _rect, _rect2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "8b97cd38c7"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "61f96f942b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73.824219 139 L 139 139 L 139 203.742188 L 73.824219 203.742188 Z M 73.824219 139 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "6b54961908"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#8b97cd38c7)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#000000",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "a04286627a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.824219 0.199219 L 65.71875 0.199219 L 65.71875 64.742188 L 0.824219 64.742188 Z M 0.824219 0.199219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6b7afd99fd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 66,
    y: 0,
    height: 65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "276f663ef8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 91 138 L 156.324219 138 L 156.324219 203.742188 L 91 203.742188 Z M 91 138 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "4a400fd376"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#8b97cd38c7)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#000000",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "1b900c9ece"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1 1 L 65.324219 1 L 65.324219 65.742188 L 1 65.742188 Z M 1 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "33f46e5b53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 66,
    y: 0,
    height: 66
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#61f96f942b)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#6b54961908)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 73, 139)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6b7afd99fd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a04286627a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d1f3c8",
    d: "M 65.355469 41.527344 C 65.355469 47.738281 62.9375 53.574219 58.550781 57.964844 C 54.019531 62.492188 48.066406 64.757812 42.117188 64.757812 C 36.164062 64.757812 30.210938 62.492188 25.683594 57.964844 L 7.640625 39.921875 C 3.253906 35.535156 0.835938 29.695312 0.835938 23.488281 C 0.835938 17.28125 3.253906 11.445312 7.640625 7.054688 C 16.703125 -2.007812 31.449219 -2.007812 40.511719 7.054688 L 58.550781 25.09375 C 62.941406 29.484375 65.355469 35.320312 65.355469 41.527344 Z M 65.355469 41.527344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#276f663ef8)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#4a400fd376)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 91, 138)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#33f46e5b53)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1b900c9ece)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3de2ff",
    d: "M 65.523438 24.488281 C 65.523438 30.699219 63.105469 36.535156 58.714844 40.921875 L 40.675781 58.964844 C 36.144531 63.492188 30.191406 65.757812 24.242188 65.757812 C 18.289062 65.757812 12.339844 63.492188 7.808594 58.964844 C 3.417969 54.574219 1 48.738281 1 42.527344 C 1 36.320312 3.417969 30.484375 7.808594 26.09375 L 25.847656 8.054688 C 34.910156 -1.007812 49.652344 -1.007812 58.714844 8.054688 C 63.105469 12.445312 65.523438 18.28125 65.523438 24.488281 Z M 65.523438 24.488281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#2200ed",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(127.078187, 180.887758)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 33.671875 0 L 21.09375 -32.640625 L 12.375 -32.640625 L -0.25 0 L 7.390625 0 L 9.4375 -5.625 L 24.03125 -5.625 L 26.078125 0 Z M 22.125 -11.640625 L 11.296875 -11.640625 L 16.734375 -26.625 Z M 22.125 -11.640625 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#2200ed",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(159.572537, 180.887758)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 10.171875 0 L 10.171875 -32.640625 L 3.234375 -32.640625 L 3.234375 0 Z M 10.171875 0 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#2200ed",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(172.002533, 180.887758)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 18.796875 0.59375 C 26.234375 0.59375 30.34375 -3.375 32.6875 -7.4375 L 26.71875 -10.328125 C 25.34375 -7.640625 22.40625 -5.578125 18.796875 -5.578125 C 13.109375 -5.578125 8.8125 -10.125 8.8125 -16.296875 C 8.8125 -22.46875 13.109375 -27.015625 18.796875 -27.015625 C 22.40625 -27.015625 25.34375 -24.90625 26.71875 -22.265625 L 32.6875 -25.203125 C 30.390625 -29.265625 26.234375 -33.171875 18.796875 -33.171875 C 9.25 -33.171875 1.65625 -26.328125 1.65625 -16.296875 C 1.65625 -6.265625 9.25 0.59375 18.796875 0.59375 Z M 18.796875 0.59375 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#2200ed",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(204.643685, 180.887758)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 33.671875 0 L 21.09375 -32.640625 L 12.375 -32.640625 L -0.25 0 L 7.390625 0 L 9.4375 -5.625 L 24.03125 -5.625 L 26.078125 0 Z M 22.125 -11.640625 L 11.296875 -11.640625 L 16.734375 -26.625 Z M 22.125 -11.640625 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#2c0afa",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.140684, 180.887758)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#2c0afa",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.300845, 225.137755)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 29.265625 0 L 29.265625 -29.3125 L 22.984375 -29.3125 L 22.984375 -17.796875 L 9.140625 -17.796875 L 9.140625 -29.3125 L 2.90625 -29.3125 L 2.90625 0 L 9.140625 0 L 9.140625 -12.296875 L 22.984375 -12.296875 L 22.984375 0 Z M 29.265625 0 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#2c0afa",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(137.537372, 225.137755)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 23.640625 0 L 23.640625 -5.40625 L 9.140625 -5.40625 L 9.140625 -12.21875 L 23.328125 -12.21875 L 23.328125 -17.578125 L 9.140625 -17.578125 L 9.140625 -23.953125 L 23.640625 -23.953125 L 23.640625 -29.3125 L 2.90625 -29.3125 L 2.90625 0 Z M 23.640625 0 "
  }))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    fill: "#2c0afa",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(162.271743, 225.137755)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 30.234375 0 L 18.9375 -29.3125 L 11.109375 -29.3125 L -0.21875 0 L 6.640625 0 L 8.484375 -5.046875 L 21.578125 -5.046875 L 23.421875 0 Z M 19.859375 -10.453125 L 10.15625 -10.453125 L 15.03125 -23.90625 Z M 19.859375 -10.453125 "
  }))))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    fill: "#2c0afa",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(191.443401, 225.137755)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 21.53125 0 L 21.53125 -5.484375 L 9.140625 -5.484375 L 9.140625 -29.3125 L 2.90625 -29.3125 L 2.90625 0 Z M 21.53125 0 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#2c0afa",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(213.541763, 225.137755)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.953125 0 L 15.953125 -23.8125 L 24.46875 -23.8125 L 24.46875 -29.3125 L 1.09375 -29.3125 L 1.09375 -23.8125 L 9.671875 -23.8125 L 9.671875 0 Z M 15.953125 0 "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#2c0afa",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(238.232195, 225.137755)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 29.265625 0 L 29.265625 -29.3125 L 22.984375 -29.3125 L 22.984375 -17.796875 L 9.140625 -17.796875 L 9.140625 -29.3125 L 2.90625 -29.3125 L 2.90625 0 L 9.140625 0 L 9.140625 -12.296875 L 22.984375 -12.296875 L 22.984375 0 Z M 29.265625 0 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAica);
export default __webpack_public_path__ + "static/media/aica.b80582338541ffb63413c8b560dae869.svg";
export { ForwardRef as ReactComponent };